export var MapEditMode;
(function (MapEditMode) {
    MapEditMode["CreateMarker"] = "create_marker";
    MapEditMode["MoveMarker"] = "move_marker";
    MapEditMode["CreateTrack"] = "create_track";
    MapEditMode["UploadTrack"] = "upload_track";
    MapEditMode["MoveTrack"] = "move_track";
    MapEditMode["CreateTrackSpotResult"] = "create_track_spot_result";
    MapEditMode["CreateTrackSpotControl"] = "create_track_spot_control";
    MapEditMode["CreateTrackSpotNavigation"] = "create_track_spot_navigation";
    MapEditMode["MoveTrackSpot"] = "move_track_spot";
})(MapEditMode || (MapEditMode = {}));
//# sourceMappingURL=MapEditMode.js.map